// extracted by mini-css-extract-plugin
export var paginationComponent = "G_b6";